import React from 'react'
import type { ReactElement } from 'react'
import discount from './assets/discount.svg'

type DiscountInputProps = {
  discountCode: string
  discountCodeState: string
  discountCodeValid: boolean | null
  onDiscountCodeSubmitted: () => void
  setDiscountCode: (code: string) => void
  setDiscountCodeValid: (value: boolean | null) => void
}

const DiscountInput = ({
  discountCode, discountCodeState, discountCodeValid, onDiscountCodeSubmitted, setDiscountCode, setDiscountCodeValid
}: DiscountInputProps): ReactElement => {
  const onDiscountCodeChanged = (value: string) => {
    setDiscountCode(value)
    setDiscountCodeValid(null)
  }
  return (
    <div className="discountCode-header">
      <h2 className="heading-with-image">
        <img
          alt=""
          className="icon tms-discount-icon"
          aria-hidden="true"
          loading="lazy"
          src={discount} width="15" height="16"
        />
        Enter a Discount Code
      </h2>

      <div className="discountCode-form" >
        <label htmlFor="code" className="discountCode-label">Discount code</label>
        <div className="discountCode-input-with-button">
          <input type="text" name="code" className="discountCode-input" placeholder="Discount Code" onChange={({ target: { value } }) => onDiscountCodeChanged(value)} value={discountCodeState} />
          <input onClick={onDiscountCodeSubmitted} type="submit" value="Apply" className="button discountCode-button"/>
        </div>
        {
          discountCode && (
            <span className="discount-note">Discount &apos;{discountCode}&apos; has been applied</span>
          )
        }
        {
          discountCodeValid === false &&
            <div className="basket-warning">
              Discount code is not valid.
            </div>
        }
      </div>
    </div>
  )
}

export default DiscountInput
